var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"upline":"","title":_vm.$t('account_order_details.title'),"bgImage":false}},[_c('TransactionDetail',{attrs:{"type":"order","transaction_uuid":_vm.$route.params.order_uuid}}),_c('VButtonGroup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }